import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

function Landing() {
  const navigate = useNavigate();

  return (
    <div className="contenedor" style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center'
    }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 className="titulo" style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>
          Tu Mano Dice
        </h1>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <p className="subtitulo" style={{ fontSize: '1.3rem' }}>
            El Maestro Solis revela lo que tus líneas guardan
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
          style={{ marginTop: '3rem' }}
        >
          <div style={{ 
            fontSize: '4rem', 
            marginBottom: '2rem',
            animation: 'pulso 2s infinite'
          }}>
            🌙 ✋ 🔮
          </div>
          
          <button 
            className="boton" 
            onClick={() => navigate('/lectura')}
            style={{ fontSize: '1.2rem', padding: '1.2rem 3rem' }}
          >
            Descubrir mi destino
          </button>
          
          <p style={{ 
            marginTop: '2rem', 
            color: 'var(--color-texto-suave)',
            fontSize: '0.9rem'
          }}>
            Análisis de mano real • Audio del Maestro Solis • Resultado inmediato
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default Landing;